export const CHANGE_LOCALE = 'app/change-locale';
export const LOADER_DONE = 'app/loader-done';
export const HIDE_COOKIES = 'app/hide-cookies';
export const APPLY_FILTERS = 'app/apply-filters';
export const CLEAR_FILTERS = 'app/clear-filters';
